/* eslint-disable max-len */
import ActvityLogThumbnail from '../assets/ActLogThumb.jpg';
import AIDocumentManagerThumbnail from '../assets/AIDocManagerThumb.jpg';
import BRSRThumbnail from '../assets/BRSRThumb.jpg';
import CAMain from '../assets/CAMain.jpg';
import CarbonCreditThumbnail from '../assets/CarbonCreditThumb.jpg';
import DataCollectionThumb from '../assets/DataCollectionThumb.jpg';
import DecarbSolThumbnail from '../assets/DecarbSolutionsThumb.jpg';
import EmissionAnalyticsThumbnail from '../assets/EmissionsAnalyticsThumb.jpg';
import ESGMain from '../assets/ESGMain.jpg';
import ESGServiceThumbnail from '../assets/ESGServiceThumbnail.jpg';
import GRIThumbnail from '../assets/GRIThumbnail.jpg';
import HomePEdu from '../assets/HomePEdu.png';
import HomeThumbnail from '../assets/HomeThumb.jpg';
import NetZeroSimThumbnail from '../assets/NetZeroSimulatorThumb.jpg';
import NetZeroStrategyThumbnail from '../assets/NetZeroStrategy.jpg';
import NetZeroTargetThumbnail from '../assets/NZTargetThumb.jpg';
import PeerThumbnail from '../assets/PeerThumbnail.jpg';
import ReportStudioThumbnail from '../assets/ReportStudioThumb.jpg';
import RSALMain from '../assets/RSALMain.jpg';
import SdgPrioThumbSnail from '../assets/SDGPrioritiesThumb.jpg';
import StakeEngageThumbnail from '../assets/StakeholderEngThumb.jpg';
import StrategyMain from '../assets/StrategyMain.jpg';
import TCFDThumbnail from '../assets/TCFDThumbnail.jpg';
import {Routes, subRoutes} from '../constants/Routes';

const assetUrl = `${process.env.REACT_APP_PUBLIC_ASSETS_URL}/demoVideos/ca/`;
const assetUrlStrategy = `${process.env.REACT_APP_PUBLIC_ASSETS_URL}/demoVideos/strategy/`;

export const platformEduArray = [
  {
    key: 'home',
    title: 'Home',
    shortTitle: 'Home',
    description: 'Central module for accessing core platform features.',
    videoPageTitle: 'Sustainability & Climate Intelligence Platform',
    videoPageDescription:
      'A centralized platform to manage carbon emissions, ESG performance, and net-zero initiatives using data-driven insights and automation.',
    icon: HomePEdu,
    videoData: [
      {
        subKey: 'home',
        subTitle: 'Home',
        thumbnail: HomeThumbnail,
        url: `${assetUrl}Home page.mp4`,
        route: Routes.HOME
      }
    ]
  },
  {
    key: 'ca',
    title: 'Carbon Accounting',
    shortTitle: 'CA',
    description: 'Tools to capture and analyze organizational emissions data.',
    videoPageTitle: 'Carbon Accounting & Emissions Management',
    videoPageDescription:
      'Measure, analyze, and track Scope 1, Scope 2, and Scope 3 emissions with standardized methodologies, validated data, and actionable analytics.',
    icon: CAMain,
    videoData: [
      {
        subKey: 'dataCollection',
        subTitle: 'Data Collection',
        thumbnail: DataCollectionThumb,
        url: `${assetUrl}Data Collection.mp4`,
        route: `${Routes.ORG_MANAGER}${subRoutes.infraProfile}`
      },
      {
        subKey: 'emissionAnalytics',
        subTitle: 'Emission Analytics',
        thumbnail: EmissionAnalyticsThumbnail,
        url: `${assetUrl}Emission Analytics.mp4`,
        route: `${Routes.NET_ZERO}${subRoutes.nzmGeneral}`
      },
      {
        subKey: 'aIDocumentManager',
        subTitle: 'AI Document Manager',
        thumbnail: AIDocumentManagerThumbnail,
        url: `${assetUrl}AI Document Manager.mp4`,
        route: `${Routes.OCR}/main`
      }
    ]
  },
  {
    key: 'esg',
    title: 'ESG Reporting',
    shortTitle: 'ESG',
    description: 'Supports global sustainability frameworks and disclosures.',
    videoPageTitle: 'ESG Reporting & Disclosures',
    videoPageDescription:
      'Prepare compliant ESG reports aligned with global and regulatory frameworks, ensuring transparency, accuracy, and stakeholder readiness.',
    icon: ESGMain,
    videoData: [
      {
        subKey: 'gri',
        subTitle: 'GRI',
        thumbnail: GRIThumbnail,
        url: `${assetUrl}Global Reporting Initiative.mp4`,
        route: `${Routes.ESG}${subRoutes.framework}`
      },
      {
        subKey: 'brsr',
        subTitle: 'BRSR',
        thumbnail: BRSRThumbnail,
        url: `${assetUrl}BRSR.mp4`,
        route: `${Routes.ESG}${subRoutes.framework}`
      },
      {
        subKey: 'tcfd',
        subTitle: 'TCFD',
        thumbnail: TCFDThumbnail,
        url: `${assetUrl}TCFD.mp4`,
        route: `${Routes.ESG}${subRoutes.framework}`
      },
      {
        subKey: 'peerBenchmarkingGapAnalysis',
        subTitle: 'Peer Benchmarking and Gap Analysis',
        thumbnail: PeerThumbnail,
        url: `${assetUrl}Peer Benchmarking and Gap Analysis.mp4`,
        route: `${Routes.ESG}${subRoutes.peer_bechmarking}`
      }
    ]
  },
  {
    key: 'strategy',
    title: 'Net Zero Strategy',
    shortTitle: 'NZS',
    description: 'Solutions to plan and achieve long-term climate goals.',
    videoPageTitle: 'Net Zero Planning & Decarbonization',
    videoPageDescription:
      'Define targets, simulate scenarios, and implement reduction strategies to achieve long-term net-zero and climate commitments.',
    icon: StrategyMain,
    videoData: [
      {
        subKey: 'stakeEngagement',
        subTitle: 'Stakeholder Engagement',
        thumbnail: StakeEngageThumbnail,
        url: `${assetUrlStrategy}Stakeholder Engagement.mp4`,
        route: ''
      },
      {
        subKey: 'sdgPriority',
        subTitle: 'My SDG Priorities',
        thumbnail: SdgPrioThumbSnail,
        url: `${assetUrlStrategy}My SDG Priorities.mp4`,
        route: ''
      },
      {
        subKey: 'netZeroTarget',
        subTitle: 'My Net Zero Target',
        thumbnail: NetZeroTargetThumbnail,
        url: `${assetUrlStrategy}My_Net_Zero_Targets.mp4`,
        route: ''
      },
      {
        subKey: 'netZeroSimulator',
        subTitle: 'Net Zero Simulator',
        thumbnail: NetZeroSimThumbnail,
        url: `${assetUrlStrategy}Net_Zero_Simulator.mp4`,
        route: ''
      },
      {
        subKey: 'esgService',
        subTitle: 'ESG Service',
        thumbnail: ESGServiceThumbnail,
        url: `${assetUrlStrategy}ESG_Service.mp4`,
        route: ''
      },
      {
        subKey: 'decarbonizationSolutions',
        subTitle: 'Decarbonization Solutions',
        thumbnail: DecarbSolThumbnail,
        url: `${assetUrlStrategy}Decarbonization Solutions.mp4`,
        route: ''
      },
      {
        subKey: 'carbonCredit',
        subTitle: 'Carbon Credit',
        thumbnail: CarbonCreditThumbnail,
        url: `${assetUrlStrategy}Carbon_Credits.mp4`,
        route: ''
      },
      {
        subKey: 'netZeroStrategy',
        subTitle: 'Net Zero Strategy',
        thumbnail: NetZeroStrategyThumbnail,
        url: `${assetUrlStrategy}My_Net_Zero_Strategy.mp4`,
        route: ''
      }
    ]
  },
  {
    key: 'rStudioALog',
    title: 'Report Studio and Activity Log',
    shortTitle: 'RS & AL',
    description: 'Generate reports and monitor all platform activities.',
    videoPageTitle: 'Reporting, Monitoring & Audit Trail',
    videoPageDescription:
      'Generate reports, monitor activities, and maintain a complete audit trail for governance, compliance, and performance tracking.',
    icon: RSALMain,
    videoData: [
      {
        subKey: 'rStudio',
        subTitle: 'Report Studio',
        thumbnail: ReportStudioThumbnail,
        url: `${assetUrl}Report Studio.mp4`,
        route: Routes.REPORT_STUDIO
      },
      {
        subKey: 'activityLog',
        subTitle: 'Activity Log',
        thumbnail: ActvityLogThumbnail,
        url: `${assetUrl}Activity_Logs.mp4`,
        route: Routes.ACTIVITY_LOG
      }
    ]
  }
];
